import { Panel, PanelGroup, PanelResizeHandle } from '@southfields-digital/mxmz-react-ui';
import { useParams } from 'react-router-dom';

import MatchControl from 'src/components/MatchControl';
import QuickControl from 'src/components/QuickControl/QuickControl';

function LayoutMatchControl() {
  const { rundownId } = useParams<{ rundownId: string }>();

  if (!rundownId) return null;

  return (
    <div className="max-w-2xl w-full h-full mx-auto [&>div]:bg-elevated-1">
      <PanelGroup direction="vertical">
        <Panel defaultSize={70}>
          <MatchControl rundownId={rundownId} variant="extended" />
        </Panel>
        <PanelResizeHandle />
        <Panel defaultSize={30}>
          {/* @TO-DO: check if we can remove this key */}
          <QuickControl key={Math.random()} />
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default LayoutMatchControl;
